import { Routes, Route, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react'
import HomePage from './views/HomePage'
import DashboardPage from './views/DashboardPage'
import TripPage from './views/TripPage'
import ProfilePage from './views/ProfilePage'
import SettingsPage from './views/SettingsPage'
import TeamDetailsPage from './views/TeamDetailsPage'
import SignInPage from './views/SignInPage'
import SignUpPage from './views/SignUpPage'
import SharedPage from './views/SharedPage'
import UserTeamsPage from './views/UserTeamsPage'
import AboutPage from './views/AboutPage'
import ContactPage from './views/ContactPage'
import HelpPage from './views/HelpPage'
import PrivacyPage from './views/PrivacyPage'
import TermsPage from './views/TermsPage'
import FAQPage from './views/FAQPage'
import { Toaster } from './components/ui/toaster'


function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/shared/:shareToken" element={<SharedPage />} />
      
      {/* Public content pages */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/help" element={<HelpPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/faq" element={<FAQPage />} />
      
      {/* Protected routes */}
      <Route path="/dashboard" element={
        <>
          <SignedIn>
            <DashboardPage />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </>
      } />
      
      <Route path="/trip" element={
        <>
          <SignedIn>
            <TripPage />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </>
      } />
      
      <Route path="/profile" element={
        <>
          <SignedIn>
            <ProfilePage />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </>
      } />
      
      <Route path="/settings" element={
        <>
          <SignedIn>
            <SettingsPage />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </>
      } />

      <Route path="/team/:id" element={
        <>
          <SignedIn>
            <TeamDetailsPage />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </>
      } />

      <Route path="/user/:userId/teams" element={
        <>
          <SignedIn>
            <UserTeamsPage />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
        </>
      } />
      
      {/* Catch all route */}
      <Route path="*" element={
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">404 - Page Not Found</h1>
            <p className="text-gray-600 mb-6">The page you're looking for doesn't exist.</p>
            <button
              onClick={() => window.location.href = '/'}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors"
            >
              Go Home
            </button>
          </div>
        </div>
      } />
    </Routes>
    <Toaster />

    </>
  )
}

export default App